/**
 * Tarjetas del panel que alimentan la parte persona del F22 AT 2026. Única lista: la usan
 * el cargador de la pantalla (cargadores.js) y el esquema del servidor (para no calcular
 * con cargas por revisar).
 */
const TARJETAS_PERSONA = [
  { id: 'sueldos', titulo: 'Sueldos y pensiones', fuente: 'DJ 1887' },
  { id: 'intereses', titulo: 'Intereses bancarios', fuente: 'DJ 1890' },
  { id: 'retiros', titulo: 'Retiros y dividendos', fuente: 'DJ 1948' },
  { id: 'educacion', titulo: 'Crédito por gastos en educación', fuente: 'Formulario de cesión' },
];

module.exports = { TARJETAS_PERSONA };
